<script>
import options from './PersonalFundraising.options'
export default options
</script>

<template>
  <article
    class="kb-personal-fundraising"
    :class="{ 'kb-personal-fundraising--submitting': isSubmitting }"
  >

    <div>
      <section class="kb-personal-fundraising__about">
  
        <h2 class="kb-personal-fundraising__form-title">
          {{ getLabel('fundraiseAbout') }}
        </h2>
  
        <p>{{getLabel('informationAboutFundraiseReason') }}</p>

        <section class="kb-personal-fundraising__form-wrapper" aria-live="polite">
          <div class="kb-personal-fundraising__input-wrapper">
            <FormInputTextField
            fieldName="firstName"
            :modelValue="firstName"
              v-model="firstName"
              :label="getLabel('firstNameLabel')"
              :readOnly="isReadOnly.firstName"
              :isValidationError="displayError && !isFirstNameValid"
              :errorMessageLabel="getLabel('firstNameErrorLabel')"
              isRequired
              />
            </div>
            <div class="kb-personal-fundraising__input-wrapper">
              <FormInputTextField
              fieldName="lastName"
              :modelValue="lastName"
              v-model="lastName"
              :label="getLabel('lastNameLabel')"
              :readOnly="isReadOnly.lastName"
              :isValidationError="displayError && !isLastNameValid"
              :errorMessageLabel="getLabel('lastNameErrorLabel')"
              isRequired
              />
            </div>
        </section>

        <FormInputTextField
          v-model="headline"
          fieldName="personalFundraising"
          isRequired
          :label="getLabel('fundraiseHeadline')"
          :isValidationError="displayError && !headlineFilled"
          :errorMessageLabel="getLabel('validationHeadline')"
          maxlength="75"
        />

        <section class="kb-personal-fundraising__form-wrapper" aria-live="polite">
          <div class="kb-personal-fundraising__input-wrapper">
            <template v-if="isMindegave">
              <div class="Form__Element FormTextbox ValidationRequired">
                <label
                  for="personalFundraising__birth"
                  class="Form__Element__Caption kb-personal-fundraising__label"
                >
                  {{ getLabel('dateOfbirth') }}
                </label>
                <VueDatePicker
                  ref="datePickerRefDateOfBirth"
                  arrow-navigation
                  v-model="dateOfbirth"
                  locale="da"
                  select-text="Vælg"
                  cancel-text="Annuller"
                  model-type=""
                  :enable-time-picker="false"
                  :clearable="false"
                  :alt-position="customPosition"
                  id="personalFundraising__birth"
                  aria-describedby="personalFundraising__birthDesc"
                  placeholder="DD - MM - ÅÅÅÅ"
                  format="dd-MM-yyyy"
                  :class="{ 'dp__validation-error': displayError && !dateOfbirthFilled }"
                >
                  <template #input-icon>
                    <div class="input-slot-image">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.5 3H3.75V4.5H2.25H1.5V6.75H2.25V5.25H3.75V6.75H4.5V5.25H9V6.75H9.75V5.25H14.25V6.75H15V5.25H19.5V6.75H20.25V5.25H21.75V9H2.25H1.5V9.75V19.5V20.25H22.5V19.5V9.75V9V4.5H21.75H20.25V3H19.5V4.5H15V3H14.25V4.5H9.75V3H9V4.5H4.5V3ZM21.75 19.5V9.75H2.25L2.25 19.5H21.75Z"
                          fill="#3C3C3C"
                        />
                      </svg>
                    </div>
                  </template>
                  <template #action-select>
                    <button class="custom-select" @click="selectDateOfBirth">
                      Vælg
                    </button>
                  </template>
                </VueDatePicker>
                <p
                  class="kb-forms Form__Element__ValidationError"
                  v-if="displayError && !dateOfbirthFilled"
                >
                  {{ getLabel('validationDateOfbirth') }}
                </p>
              </div>
            </template>
          </div>
  
          <div class="kb-personal-fundraising__input-wrapper">
            <template v-if="isMindegave">
              <div class="Form__Element FormTextbox ValidationRequired">
                <label
                  for="personalFundraising__death"
                  class="Form__Element__Caption kb-personal-fundraising__label"
                  >{{ getLabel('dateOfdeath') }}
                </label>
                <VueDatePicker
                  ref="datePickerRefDateOfDeath"
                  v-model="dateOfdeath"
                  model-type=""
                  locale="da"
                  select-text="Vælg"
                  cancel-text="Annuller"
                  :enable-time-picker="false"
                  :clearable="false"
                  :alt-position="customPosition"
                  id="personalFundraising__death"
                  aria-describedby="personalFundraising__deathDesc"
                  placeholder="DD - MM - ÅÅÅÅ"
                  format="dd-MM-yyyy"
                  :class="{ 'dp__validation-error': displayError && !dateOfdeathFilled }"
                >
                  <template #input-icon>
                    <div class="input-slot-image">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.5 3H3.75V4.5H2.25H1.5V6.75H2.25V5.25H3.75V6.75H4.5V5.25H9V6.75H9.75V5.25H14.25V6.75H15V5.25H19.5V6.75H20.25V5.25H21.75V9H2.25H1.5V9.75V19.5V20.25H22.5V19.5V9.75V9V4.5H21.75H20.25V3H19.5V4.5H15V3H14.25V4.5H9.75V3H9V4.5H4.5V3ZM21.75 19.5V9.75H2.25L2.25 19.5H21.75Z"
                          fill="#3C3C3C"
                        />
                      </svg>
                    </div>
                  </template>
                  <template #action-select>
                    <button class="custom-select" @click="selectDateOfDeath">
                      Vælg
                    </button>
                  </template>
                </VueDatePicker>
                <p
                  class="kb-forms Form__Element__ValidationError"
                  v-if="displayError && !dateOfdeathFilled"
                >
                  {{ getLabel('validationDateOfdeath') }}
                </p>
              </div>
            </template>
          </div>
        </section>
  
        <section class="kb-personal-fundraising__form-wrapper" aria-live="polite">
          <div v-if="!hideFundraisingTarget" class="kb-personal-fundraising__input-wrapper">
            <FormInputTextField
              v-model="fundraisingTarget"
              fieldName="personalFundraising__fundraisingTarget"
              isRequired
              :label="getLabel('fundraiseTarget')"
              :isValidationError="displayError && !fundraisingTargetFilled"
              :errorMessageLabel="getLabel('validationFundraisingTarget')"
              type="number"
            />
          </div>
  
          <div v-if="!hideFundraisingEndDate" class="kb-personal-fundraising__input-wrapper"> 
            <div class="Form__Element FormTextbox ValidationRequired">
              <label
                for="personalFundraising__endDate"
                class="Form__Element__Caption kb-personal-fundraising__label"
              >
                {{ getLabel('endDate') }}
              </label>
              <VueDatePicker
                ref="datePickerRefEndDate"
                v-model="endDate"
                model-type=""
                locale="da"
                select-text="Vælg"
                cancel-text="Annuller"
                :enable-time-picker="false"
                :clearable="false"
                :alt-position="customPosition"
                id="personalFundraising__endDate"
                aria-describedby="personalFundraising__endDateDesc"
                placeholder="DD - MM - ÅÅÅÅ"
                :min-date="new Date()"
                format="dd-MM-yyyy"
                :class="{ 'dp__validation-error': displayError && !endDateFilled }"
              >
                <template #input-icon>
                  <div class="input-slot-image">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.5 3H3.75V4.5H2.25H1.5V6.75H2.25V5.25H3.75V6.75H4.5V5.25H9V6.75H9.75V5.25H14.25V6.75H15V5.25H19.5V6.75H20.25V5.25H21.75V9H2.25H1.5V9.75V19.5V20.25H22.5V19.5V9.75V9V4.5H21.75H20.25V3H19.5V4.5H15V3H14.25V4.5H9.75V3H9V4.5H4.5V3ZM21.75 19.5V9.75H2.25L2.25 19.5H21.75Z"
                        fill="#3C3C3C"
                      />
                    </svg>
                  </div>
                </template>
                <template #action-select>
                  <button class="custom-select" @click="selectEndDate">
                    Vælg
                  </button>
                </template>
              </VueDatePicker>
              <p
                class="kb-forms Form__Element__ValidationError"
                v-if="displayError && !endDateFilled"
              >
                {{ getLabel('validationEndDate') }}
              </p>
            </div>
          </div>

          <div v-if="hideFundraisingTarget" class="kb-personal-fundraising__input-wrapper">
          </div>

          <div v-if="hideFundraisingEndDate" class="kb-personal-fundraising__input-wrapper">
          </div>

        </section>
  
        <section v-if="showFundraiseCard" class="kb-personal-fundraising__about__card">
          <div class="kb-personal-fundraising__about__card__content-container">
            <div class="kb-personal-fundraising__about__card__icon-wrapper">
              <div class="kb-personal-fundraising__about__card__circle">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Information">
                    <path
                      id="Vector"
                      d="M19.3442 15.8093C20.0454 15.8093 20.6139 15.2408 20.6139 14.5395C20.6139 13.8383 20.0454 13.2698 19.3442 13.2698C18.6429 13.2698 18.0744 13.8383 18.0744 14.5395C18.0744 15.2408 18.6429 15.8093 19.3442 15.8093Z"
                      fill="#005B78"
                    />
                    <path
                      id="Vector_2"
                      d="M19.3442 2.66504C15.9157 2.66504 12.5641 3.68171 9.71342 5.58649C6.86272 7.49128 4.64086 10.1986 3.32882 13.3662C2.01679 16.5337 1.6735 20.0192 2.34237 23.3818C3.01124 26.7444 4.66223 29.8332 7.08656 32.2575C9.51088 34.6819 12.5997 36.3329 15.9623 37.0017C19.3249 37.6706 22.8104 37.3273 25.9779 36.0153C29.1455 34.7032 31.8528 32.4814 33.7576 29.6307C35.6624 26.78 36.6791 23.4284 36.6791 19.9999C36.6741 15.4039 34.8462 10.9976 31.5963 7.74775C28.3465 4.49789 23.9402 2.66996 19.3442 2.66504ZM19.3442 35.9395C16.1916 35.9395 13.1099 35.0046 10.4886 33.2532C7.86739 31.5017 5.82438 29.0123 4.61796 26.0997C3.41153 23.1872 3.09588 19.9822 3.71091 16.8903C4.32594 13.7983 5.84403 10.9582 8.07322 8.72897C10.3024 6.49979 13.1426 4.98169 16.2345 4.36666C19.3265 3.75163 22.5314 4.06729 25.444 5.27371C28.3565 6.48014 30.8459 8.52315 32.5974 11.1444C34.3489 13.7656 35.2837 16.8474 35.2837 19.9999C35.28 24.2262 33.5995 28.2784 30.611 31.2668C27.6226 34.2552 23.5705 35.9358 19.3442 35.9395Z"
                      fill="#005B78"
                    />
                    <path
                      id="Vector_3"
                      d="M31.3582 12.2046C29.9986 10.102 28.1133 8.39111 25.889 7.24134C23.6647 6.09157 21.1786 5.54285 18.677 5.64953C16.1754 5.75621 13.7451 6.51459 11.6268 7.84955C9.50847 9.18451 7.77566 11.0497 6.60002 13.2604L7.83258 13.9116C8.96456 11.7794 10.6689 10.0053 12.7539 8.78861C14.8389 7.57193 17.2219 6.96097 19.6351 7.02439C22.0483 7.08782 24.396 7.82312 26.4142 9.14764C28.4324 10.4722 30.0411 12.3334 31.0596 14.5221C32.078 16.7108 32.4657 19.1401 32.1792 21.5371C31.8926 23.9341 30.9431 26.2036 29.4374 28.0905C27.9317 29.9774 25.9296 31.4069 23.656 32.2184C21.3824 33.0298 18.9276 33.1909 16.5675 32.6837C9.68839 31.2046 5.34886 24.9302 6.42793 18.2139L8.24653 18.6046L8.53955 17.2418L5.33955 16.5488L5.19072 17.2325C3.53025 24.9674 8.39537 32.3535 16.2791 34.0465C17.2801 34.2629 18.3014 34.372 19.3256 34.3721C21.9061 34.3661 24.4373 33.6653 26.6534 32.3432C28.8694 31.0211 30.6885 29.1266 31.9195 26.8587C33.1506 24.5908 33.7481 22.0332 33.6493 19.4547C33.5505 16.8761 32.7591 14.3717 31.3582 12.2046Z"
                      fill="#005B78"
                    />
                    <path
                      id="Vector_4"
                      d="M16.2372 25.5721V26.9675H22.9535V25.5721H20.293V16.9814H16.5907V18.3768H18.8976V25.5721H16.2372Z"
                      fill="#005B78"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div class="kb-personal-fundraising__about__card__content">
              <h2 class="kb-personal-fundraising__about__card__title">
                {{ getLabel('cardTitle') }}
              </h2>
              <p class="kb-personal-fundraising__about__card__paragraph">
                {{ getLabel('cardParagraph') }}
              </p>
            </div>
            <div class="kb-personal-fundraising__about__card__button-wrapper">
              <a
                :href="getLabel('cardButtonHref')"
                :title="getLabel('cardButtonTitle')"
                target="_blank"
                class="kb-button kb-button--full-color-spot"
              >
                {{ getLabel('cardButtonContent') }}
              </a>
            </div>
          </div>
        </section>        
      </section>
  
      <section class="kb-personal-fundraising__personalization-section">
        <h2>{{ getLabel('fundraiseSecondHeadline') }}</h2>
        <p id="fundraisingImageUploadDesc">
          {{ getLabel('fundraiseDescriptionText') }}
        </p>
  
        <div
          class="Form__Element__Caption kb-personal-fundraising__upload-button-label kb-personal-fundraising__label"
          ><span class="kb-personal-fundraising__upload-button-label-span">
            Indsamlingsbillede
          </span>
  
          <div
            class="Form__Element FormFileUpload kb-personal-fundraising__upload-button"
          >
            <template v-if="fundraiseImage">
              <button
                class="kb-personal-fundraising__upload-showcase"
                @click.prevent="
                  discardUploadedImage('fundraiseImage', fundraiseImage.id)
                "
              >
                <img
                  :src="fundraiseImage.url"
                  alt=""
                  class="kb-personal-fundraising__upload-showcase__image"
                />
                <div
                  class="kb-personal-fundraising__upload-showcase__button-content"
                >
                  {{ fundraiseImage.name }}
                  <span
                    v-if="fundraiseImage.size"
                    class="kb-personal-fundraising__upload-showcase__upload-text"
                  >
                    Filstørrelse {{ formatFilesize(fundraiseImage.size) }}
                  </span>
                </div>
                <span
                  class="kb-personal-fundraising__upload-showcase__remove-upload"
                >
                  {{ getLabel('removeUpload') }}
                </span>
              </button>
            </template>
            <template v-else>
              <label
                for="fundraisingImageUpload"
                class="Form__Element__Caption kb-personal-fundraising__upload-button-label"
                :class="{
                  'kb-personal-fundraising__upload-button-label--validation-error':
                    isFundraiseImageUploadError
                }"
              >
                <div
                  v-if="!isUploadingFundraiseImage"
                  class="kb-personal-fundraising__icon"
                >
                  <svg
                    viewBox="0 0 30 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.0245 12.05L20.9907 11.6454L20.7849 11.164C19.9442 9.16166 20.1675 7.02329 21.3814 5.48143C22.5954 3.93957 24.4756 3.21748 26.7012 3.38841L25.2117 4.82562L25.9407 5.57562L27.957 3.61515C28.0529 3.52128 28.1291 3.40921 28.1811 3.28551C28.2331 3.16182 28.2599 3.02899 28.2599 2.8948C28.2599 2.76062 28.2331 2.62779 28.1811 2.50409C28.1291 2.3804 28.0529 2.26833 27.957 2.17445L25.9407 0.213989L25.2117 0.963989L26.607 2.32097C24.1024 2.18841 21.9326 3.07794 20.5582 4.83957C19.107 6.69538 18.8384 9.21399 19.8221 11.5582L20.0245 12.05Z"
                      fill="#3C3C3C"
                    />
                    <path
                      d="M18.1411 23.4186V24.4651H12.2109V23.4186H0.699239V26.3837C0.698313 26.5443 0.729262 26.7035 0.790291 26.852C0.851321 27.0006 0.941219 27.1355 1.05478 27.2491C1.16834 27.3626 1.3033 27.4525 1.45185 27.5136C1.60039 27.5746 1.75958 27.6056 1.92017 27.6046H28.083C28.4068 27.6046 28.7173 27.476 28.9463 27.247C29.1753 27.0181 29.3039 26.7075 29.3039 26.3837V23.4186H18.1411ZM28.2574 26.3837C28.2574 26.43 28.239 26.4743 28.2063 26.507C28.1736 26.5397 28.1292 26.5581 28.083 26.5581H1.92017C1.87303 26.558 1.82786 26.5392 1.79459 26.5058C1.763 26.473 1.74548 26.4292 1.74575 26.3837V24.4651H11.1644V25.5116H19.1876V24.4651H28.2574V26.3837Z"
                      fill="#3C3C3C"
                    />
                    <path
                      d="M4.88563 20.9767H2.79261V8.593C2.79261 8.54674 2.81098 8.50238 2.84369 8.46967C2.8764 8.43696 2.92077 8.41858 2.96702 8.41858H17.0949V7.37207H2.96702C2.64321 7.37207 2.33266 7.5007 2.1037 7.72967C1.87473 7.95864 1.74609 8.26919 1.74609 8.593V22.0232H4.88563V20.9767Z"
                      fill="#3C3C3C"
                    />
                    <path
                      d="M28.256 22.0232V8.593C28.256 8.26919 28.1274 7.95864 27.8984 7.72967C27.6694 7.5007 27.3589 7.37207 27.0351 7.37207H23.0234V8.41858H27.0351C27.0813 8.41858 27.1257 8.43696 27.1584 8.46967C27.1911 8.50238 27.2095 8.54674 27.2095 8.593V22.0232H28.256Z"
                      fill="#3C3C3C"
                    />
                  </svg>
                </div>
  
                <div
                  v-if="isUploadingFundraiseImage"
                  class="kb-personal-fundraising__label-content"
                >
                  Uploader billede ...
                </div>
                <div v-else class="kb-personal-fundraising__label-content">
                  <span class="kb-personal-fundraising__underline">Vælg fil</span>
                  <span
                    class="kb-personal-fundraising__upload-button-label__label-text"
                    >Understøttede filer: JPG, PNG, GIF, WebP</span
                  >
                </div>
              </label>
  
              <input
                :disabled="isUploadingFundraiseImage"
                v-on:change="fundraiseImageUploader"
                id="fundraisingImageUpload"
                type="file"
                accept=".jpg,.jpeg,.png,.gif,.webp"
                class="FormFileUpload__Input kb-personal-fundraising__upload-button-input"
                required
                aria-describedby="fundraisingImageUploadDesc"
              />
              <p
                class="kb-forms Form__Element__ValidationError Form__Element__ValidationError--image-upload"
                v-if="isFundraiseImageUploadError"
              >
                {{ getLabel('errorMessageWrongFileFormat') }}
              </p>
            </template>
          </div>
        </div>

        <FormInputRichText
            :label="getLabel('fundraiseReason')"
            :placeholder="getLabel('placeholderReason')"
            :errorMessageLabel="getLabel('validationFundraiseReason')"
            :isValidationError="displayError && !fundraiseReasonFilled"
            fieldName="fundraiseReason"
            isRequired
            v-model="fundraiseReason"
        />
  
        <div
          v-if="isMindegave"
          class="Form__Element FormTextbox FormTextbox--Textarea"
        >
          <label for="fundraiseElaboration" class="Form__Element__Caption">
            {{ getLabel('fundraiseElaboration') }}
          </label>
          <textarea
            v-model="fundraisePersonDescription"
            id="fundraiseElaboration"
            class="FormTextbox__Input"
            :class="{ 'validation-error': displayError && !fundraisePersonDescriptionFilled }"
            :placeholder="getLabel('placeholderElaboration')"
            required
            aria-required="true"
            aria-describedby="fundraiseElaboration_desc"
            aria-invalid="false"
            maxlength="2000"
          ></textarea>
          <p
            class="kb-forms Form__Element__ValidationError"
            v-if="displayError && !fundraisePersonDescriptionFilled"
          >
            {{ getLabel('validationElaboration') }}
          </p>
        </div>
      </section> 

      <section v-if="showPostalCodeInput" class="kb-personal-fundraising__postalcode">
        <FormInputTextField
          v-model="postalCode"
          fieldName="personalFundraising"
          :label="getLabel('fundraisePostalCode')"
          :isValidationError="displayError && !postalCodeValid"
          :onChangeCallback="(e) => postalCodeChanged(e.target.value)"
          :errorMessageLabel="getLabel('validationPostalCode')"
          type="number"
        />
      </section>

      <section class="kb-personal-fundraising__image-upload">
        <h2>{{ getLabel('fundraiseImageUploadTitle') }}</h2>
        <p id="fundraisingImageUploadDesc2">
          {{ getLabel('fundraiseImageUploadText') }}
        </p>
  
        <template v-if="personalStoryImage.length">
          <button
            v-for="(image, imageIndex) in personalStoryImage"
            @click="discardUploadedImage('personalStoryImage', image.id)"
            class="kb-personal-fundraising__upload-showcase"
          >
            <img
              :src="image.url"
              alt=""
              class="kb-personal-fundraising__upload-showcase__image"
            />
            <div class="kb-personal-fundraising__upload-showcase__button-content">
              {{ image.name }}
              <span
                v-if="image.size"
                class="kb-personal-fundraising__upload-showcase__upload-text"
              >
                Filstørrelse: {{ formatFilesize(image.size) }}
              </span>
            </div>
            <span class="kb-personal-fundraising__upload-showcase__remove-upload">
              {{ getLabel('removeUpload') }}
            </span>
          </button>
        </template>
  
        <button
          v-for="n in personalStoryImagesUploading"
          class="kb-personal-fundraising__upload-showcase"
        >
          <div class="kb-personal-fundraising__upload-showcase__button-content">
            Uploader billede ...
          </div>
        </button>
  
        <div
          class="Form__Element FormFileUpload kb-personal-fundraising__upload-button"
        >
          <label
            for="personalStoryImageUpload"
            class="Form__Element__Caption kb-personal-fundraising__upload-button-label"
          >
            <div class="kb-personal-fundraising__icon">
              <svg
                viewBox="0 0 30 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.0245 12.05L20.9907 11.6454L20.7849 11.164C19.9442 9.16166 20.1675 7.02329 21.3814 5.48143C22.5954 3.93957 24.4756 3.21748 26.7012 3.38841L25.2117 4.82562L25.9407 5.57562L27.957 3.61515C28.0529 3.52128 28.1291 3.40921 28.1811 3.28551C28.2331 3.16182 28.2599 3.02899 28.2599 2.8948C28.2599 2.76062 28.2331 2.62779 28.1811 2.50409C28.1291 2.3804 28.0529 2.26833 27.957 2.17445L25.9407 0.213989L25.2117 0.963989L26.607 2.32097C24.1024 2.18841 21.9326 3.07794 20.5582 4.83957C19.107 6.69538 18.8384 9.21399 19.8221 11.5582L20.0245 12.05Z"
                  fill="#3C3C3C"
                />
                <path
                  d="M18.1411 23.4186V24.4651H12.2109V23.4186H0.699239V26.3837C0.698313 26.5443 0.729262 26.7035 0.790291 26.852C0.851321 27.0006 0.941219 27.1355 1.05478 27.2491C1.16834 27.3626 1.3033 27.4525 1.45185 27.5136C1.60039 27.5746 1.75958 27.6056 1.92017 27.6046H28.083C28.4068 27.6046 28.7173 27.476 28.9463 27.247C29.1753 27.0181 29.3039 26.7075 29.3039 26.3837V23.4186H18.1411ZM28.2574 26.3837C28.2574 26.43 28.239 26.4743 28.2063 26.507C28.1736 26.5397 28.1292 26.5581 28.083 26.5581H1.92017C1.87303 26.558 1.82786 26.5392 1.79459 26.5058C1.763 26.473 1.74548 26.4292 1.74575 26.3837V24.4651H11.1644V25.5116H19.1876V24.4651H28.2574V26.3837Z"
                  fill="#3C3C3C"
                />
                <path
                  d="M4.88563 20.9767H2.79261V8.593C2.79261 8.54674 2.81098 8.50238 2.84369 8.46967C2.8764 8.43696 2.92077 8.41858 2.96702 8.41858H17.0949V7.37207H2.96702C2.64321 7.37207 2.33266 7.5007 2.1037 7.72967C1.87473 7.95864 1.74609 8.26919 1.74609 8.593V22.0232H4.88563V20.9767Z"
                  fill="#3C3C3C"
                />
                <path
                  d="M28.256 22.0232V8.593C28.256 8.26919 28.1274 7.95864 27.8984 7.72967C27.6694 7.5007 27.3589 7.37207 27.0351 7.37207H23.0234V8.41858H27.0351C27.0813 8.41858 27.1257 8.43696 27.1584 8.46967C27.1911 8.50238 27.2095 8.54674 27.2095 8.593V22.0232H28.256Z"
                  fill="#3C3C3C"
                />
              </svg>
            </div>
  
            <div class="kb-personal-fundraising__label-content">
              <span class="kb-personal-fundraising__underline">Vælg fil</span>
              <span
                class="kb-personal-fundraising__upload-button-label__label-text"
                >Understøttede filer: JPG, PNG, GIF, WebP</span
              >
            </div>
          </label>
  
          <input
            v-on:change="personalStoryImageUploader"
            id="personalStoryImageUpload"
            type="file"
            multiple
            accept=".jpg,.jpeg,.png,.gif,.webp"
            class="FormFileUpload__Input kb-personal-fundraising__upload-button-input"
            required
            aria-required="true"
            aria-describedby="fundraisingImageUploadDesc2"
          />
          <p
            class="kb-forms Form__Element__ValidationError Form__Element__ValidationError--image-upload"
            v-if="displayError && !personalStoryImageFilled"
          >
            {{ getLabel('validationPersonalStoryImage') }}
          </p>
          <p
            class="kb-forms Form__Element__ValidationError Form__Element__ValidationError--image-upload"
            v-if="isPersonalStoryImageUploadError"
          >
            {{ getLabel('errorMessageWrongFileFormat') }}
          </p>
        </div>

      </section>
  
      <section v-if="showUserConsent && !isMindegave" class="kb-personal-fundraising__user-consent">        
        <h2>{{ getLabel('userConsentTitle') }}</h2>
        <p>{{ getLabel('userConsentDescription') }}</p>

        <div class="consent-checkbox-container kb-sign-up-form__kb-form__checkbox-container">
          <input
            id="user-consent"
            type="checkbox"
            name="user-consent"
            class="kb-sign-up-form__kb-form__radio-input"
            v-model="hasConsent"
          />

          <div class="consent-checkbox-container__right">
            <label
              for="user-consent"
              class="kb-sign-up-form__kb-form__radio-label"
            >
              {{ getLabel('userConsentOption') }}
            </label>
          
            <div v-if="hasConsent">
              <label class="consent-checkbox-container__right__text-label">
                {{ getLabel('userConsentTextLabel') }}
                <TooltipComponent :tooltipText="getLabel('userConsentTextTooltip')" />
              </label>
      
              <textarea
                v-model="fundraisePersonDescription"
                id="userConsentText"
                class="FormTextbox__Input"
                :class="{ 'validation-error': displayError && !fundraisePersonDescriptionFilled }"
                :label="getLabel('userConsentTextLabel')"
                aria-invalid="false"
                maxlength="35"
              ></textarea>
      
              <p
                class="kb-forms Form__Element__ValidationError"
                v-if="displayError && !fundraisePersonDescriptionFilled"
              >
                {{ getLabel('userConsentTextErrorLabel') }}
              </p>
            </div>

          </div>
        </div>

      </section>

      <section class="kb-personal-fundraising__notification">
        <h2>{{ getLabel('notificationTitle') }}</h2>
        <p>{{ getLabel('notificationText') }}</p>
  
        <div class="kb-sign-up-form__kb-form__checkbox-container">
          <input
            v-model="notificationSms"
            id="notification-sms"
            type="checkbox"
            name="notification-sms"
            class="kb-sign-up-form__kb-form__radio-input"
          />
          <label
            for="notification-sms"
            class="kb-sign-up-form__kb-form__radio-label"
          >
            {{ getLabel('notificationSms') }}
          </label>
        </div>

        <template v-if="showPhoneInput">
          <div class="kb-personal-fundraising__input-wrapper">
            <FormInputTextField
              fieldName="phone"
              :modelValue="phone"
              v-model="phone"
              :label="getLabel('phoneLabel')"
              :readOnly="isReadOnly.phone"
              :isValidationError="displayError && !isPhoneValid"
              :errorMessageLabel="getLabel('phoneErrorLabel')"
              isRequired
              />
          </div>
        </template>
  
        <div class="kb-sign-up-form__kb-form__checkbox-container">
          <input
            v-model="notificationEmail"
            id="notification-email"
            type="checkbox"
            name="notification-email"
            class="kb-sign-up-form__kb-form__radio-input"
          />
          <label
            for="notification-email"
            class="kb-sign-up-form__kb-form__radio-label"
          >
            {{ getLabel('notificationEmail') }}
          </label>
        </div>
      </section>
  
      <section class="kb-personal-fundraising__continue-info">
        <h2 class="kb-personal-fundraising__continue-info__title">
          {{ getLabel('continueInfoTitle') }}
        </h2>
        <p class="kb-personal-fundraising__continue-info__text">
          {{ getLabel('continueInfoDescription') }}
        </p>
      </section>
    </div>

    <section class="kb-personal-fundraising__divider"></section>

    <div class="kb-personal-fundraising__navigation">
      <button
        v-if="isUpdate"
        @click.prevent="deleteButtonPressed"
        class="kb-button"
      >
        {{  getLabel('deleteButton') }}
      </button>
      <button @click.prevent="previousButtonPressed" class="kb-button">
        {{ 
          getLabel('cancelButton') }}
      </button>

      <button
        @click="nextButtonPressed"
        :disabled="disableNextButton"
        class="kb-button kb-button--full-color-spot"
      >
        {{ getLabel('submitButton') }}
      </button>
    </div>

    <div v-if="isSubmitting" class="kb-spinner-overlay">
      <div
        class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"
      ></div>
    </div>
  </article>
</template>
